import { NodeState } from './node.type';

export const NODE_REQUEST = 'NODE_REQUEST';
export const NODE_RESPONSE = 'NODE_RESPONSE';

export interface NodeRequestAction {
  type: typeof NODE_REQUEST;
  payload: NodeState;
}

export interface NodeResponseAction {
  type: typeof NODE_RESPONSE;
  payload: NodeState;
}

export type NodeActionTypes = NodeResponseAction | NodeRequestAction;

export type NodeActions = NodeActionTypes;
